/** List wizard, "Find person" step (`list.detailsStep`) — what Next says when it cannot proceed (PREC-4017). */
export const enListDetailsStep = {
	saveFailed: "The search profiles could not be saved.",
	incomplete: "One of the search profiles is incomplete. Complete or clear it before continuing.",
	/**
	 * "Use my contacts first" / "Find new people only" (PREC-3899), shown in this step and in List
	 * Settings on the lists that find people at their companies, where it replaces "Only new leads".
	 */
	contactMode: {
		title: "Who should we find?",
		hint: "You can change this later in the list's Settings step.",
		settingsHint: "You can also change this in the list's Find person step.",
		default: "Default",
		contactsFirst: "Use my contacts first",
		contactsFirstDescription:
			"People already in your Contacts at the company are used first, at no cost while their data is recent. New people are searched only for the places left.",
		/** PREC-4625: the bulk Find person run charges reused contacts, unlike the list run. */
		contactsFirstBulkDescription:
			"People already in your Contacts at the company are used first and charged like a found person. New people are searched only for the places left.",
		newPeopleOnly: "Find new people only",
		newPeopleOnlyDescription:
			"Nobody already in your Contacts is added. Contacts at the company are left out before any person is paid for, so the places go to new people. If everyone found is already a contact, the company shows “No new person among the top matches”.",
	},
};
